import { bookapiRoomCateringUpsellingActionTypes, initialBookapiRoomCateringUpsellingStateAction } from './ActionTypes';
var reducer = function (state, action) {
    if (state === void 0) { state = initialBookapiRoomCateringUpsellingStateAction; }
    switch (action.type) {
        case bookapiRoomCateringUpsellingActionTypes.RECEIVE_BOOKAPI_ROOM_CATERING_RATE_STATE:
            return {
                type: action.type,
                bookapiRoomCateringUpsellingResponse: action.roomCateringUpsellingResponse
            };
        default:
            return {
                type: action.type
            };
    }
};
export { reducer as bookapiRoomCateringUpsellingRateReducer };
